import{a as s}from"./ninox-components-KB6H56E3.js";import{l}from"./ninox-components-GQTCIGTF.js";import{m as t}from"./ninox-components-2ADN25D5.js";import{f as d}from"./ninox-components-DFJEWGV6.js";import{f as o}from"./ninox-components-MYF6AQNE.js";import{k as r}from"./ninox-components-R4FVH3NU.js";import{a}from"./ninox-components-I2GBTDK4.js";import{c as n}from"./ninox-components-YAP3BY3K.js";import e from"styled-components";var h=e(s)`
    display: flex;
    flex: 0 0 auto;
    position: relative;

    font-family: ${n.sans};

    color: ${({theme:i})=>i.text.label};

    &[aria-disabled='true'] {
        color: ${({theme:i})=>i.text.disabled};
    }

    &:focus-within[aria-invalid='true']:not([aria-disabled='true']) {
        color: ${({theme:i})=>i.text.invalid};
    }
`,m=e.div`
    display: flex;
    align-items: center;
    gap: ${t.xxx_small};

    font-size: ${r.x_small};
    font-weight: ${a.medium};
    pointer-events: none;
    overflow: hidden;
    white-space: break-spaces;

    transition-timing-function: inherit;
    transition-duration: inherit;
    transition-property: color;

    & svg {
        transition: none;
    }

    &[aria-hidden='true'] {
        display: none;
    }
`,f=e.div`
    position: relative;
    align-self: stretch;

    transition-timing-function: inherit;
    transition-duration: inherit;

    ${({theme:i})=>i.input.icon}
`,$=e.input`
    box-sizing: border-box;

    height: calc(${l.m} + 2 * ${o.tiny});
    line-height: ${l.m};
    width: 0;
    min-width: 100%;

    padding-bottom: 0;
    padding-top: 0;

    box-shadow: none !important;
    appearance: none;

    outline: none;
    border-radius: ${d.medium};
    border-style: solid;
    border-width: ${o.tiny};
    border-color: transparent;

    transition-timing-function: inherit;
    transition-duration: inherit;
    transition-property: color, background-color, outline-color, border-color;

    overflow: hidden;
    text-overflow: ellipsis;

    font-family: ${n.sans};
    font-size: ${r.medium};
    font-weight: ${a.normal};

    ${({theme:i})=>i.input.default}

    &:hover {
        ${({theme:i})=>i.input.hover}
    }

    &:focus {
        ${({theme:i})=>i.input.focus}
    }

    &:invalid {
        ${({theme:i})=>i.input.invalid.default};
    }

    &:invalid:focus {
        ${({theme:i})=>i.input.invalid.focus};
    }

    &:disabled {
        cursor: default;
        ${({theme:i})=>i.input.disabled}
    }

    &::placeholder {
        opacity: 1;
        ${({theme:i})=>i.input.placeholder};
    }
    &::placeholder-shown {
        text-overflow: ellipsis;
    }
    &:disabled::placeholder {
        opacity: 1;
        color: ${({theme:i})=>i.text.disabled};
    }
    &::-webkit-search-cancel-button {
        margin-right: ${t.x_small};
    }
    &::-webkit-calendar-picker-indicator {
        padding-right: ${t.x_small};
    }

    &[type='time'],
    &[type='date'],
    &[type='datetime-local'] {
        width: auto;
    }
`;export{h as a,m as b,f as c,$ as d};
//# sourceMappingURL=ninox-components-ME7X2R35.js.map